import _ from 'lodash';
import { CREATE_EVENT, 
    FETCH_EVENTS,FETCH_EVENT,
    DELETE_EVENT, EDIT_EVENT } from '../actions/types';



    export default (state = {}, action) => {
        switch (action.type) {
            case FETCH_EVENTS:
                //_mapKeys turns array into an object taking 'id' as a key
                //it takes action.payload array and create an obj. 
                //  ... adds them into new object
                //return {...state, ...action.payload}
                return { ...state, ..._.mapKeys(action.payload, 'id')};
            case FETCH_EVENT:
                //key-value pair in state object, find [id]:its pair
                return { ...state, [action.payload.id]:action.payload};
            case CREATE_EVENT:
                return {...state, [action.payload.id]:action.payload};
            case EDIT_EVENT:
                return { ...state, [action.payload.id]:action.payload};
            case DELETE_EVENT:
                //for DELETE_EVENT, action.payload is id itself (from action creator)
                //omit doesnt change the original state,  it create a new obj. insted
                return _.omit(state, action.payload)
            
            default:
                return state;
        }
    }
